import React from "react";

import { FormattedMessage } from "@mnemonic/intl";

const validateEmptyField = (value) => {
  if (value != null) return undefined;
  return <FormattedMessage id="validation.this.field.is.required" defaultMessage="This field is required" />;
};

export default validateEmptyField;
